import { AxiosResponse } from 'axios';
import { ReturnShippingLabelAPI } from '../../api/oms/order-details';
import {
  IReturnShippingLabelRequest,
  IReturnShippingLabelResponse,
} from '../../models/returns';

// Functions that will encompass the API call will be done here.
// You can check the API response so that all the information is available here, throw an error if not

/**
 * Fetches the Return Shipping Label and will return the Return Label Response
 * @param requestData as IReturnShippingLabelRequest
 * @returns The Response from the API or an Axios Error if empty
 */
export const GetReturnShippingLabelAPI = (
  requestData: IReturnShippingLabelRequest,
  userId: string,
  xAuthGuestToken?: string,
) => {
  return ReturnShippingLabelAPI(requestData, userId, xAuthGuestToken).then(
    (response: AxiosResponse<IReturnShippingLabelResponse>) => {
      const printLabelResponse =
        response?.data?.printReturnShippingLabelService
          ?.printReturnLabelResponse ||
        response?.data?.PrintReturnShippingLabelService
          ?.PrintReturnLabelResponse;
      if (!printLabelResponse) {
        throw new Error('No label found');
      }
      return printLabelResponse;
    },
  );
};
